import React from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Collapse, Divider } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ArticleIcon from '@mui/icons-material/Article';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import CommentIcon from '@mui/icons-material/Comment';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useHistory } from 'react-router-dom';

const ExhibitionNav = ({ permissions, currentPath, openExhibitionMenu, handleClickExhibitionMenu, openExhibitionBooth, handleClickExhibitionBooth, openExhibitionExhibitor, handleClickExhibitionExhibitor, openExhibitionGuestFrom, handleClickExhibitionGuestFrom, openExhibitionSetting, handleClickExhibitionSetting }) => {
  const history = useHistory();

  return (
    <div>
      {currentPath !== '/admin/events' && (
        <>
          <Divider sx={{ my: 1 }} />
          <Divider sx={{ my: 1 }} />
          <ListItemButton onClick={handleClickExhibitionMenu} sx={{ color: '#1976d2' }}>
            <ListItemIcon sx={{ color: '#1976d2' }}>
              <DashboardIcon onClick={() => history.push('/admin/exhibition/dashbord')} />
            </ListItemIcon>
            <ListItemText primary="Exhibition MS" sx={{ color: '#1976d2' }} />
            {openExhibitionMenu ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
          </ListItemButton>
        </>
      )}
      <Collapse in={openExhibitionMenu} timeout="auto" unmountOnExit>
        {currentPath !== '/admin/events' && (
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/dashbord')}>
              <ListItemIcon sx={{ color: '#1976d2' }}>
                <DashboardIcon onClick={() => history.push('/admin/exhibition/dashbord')} />
              </ListItemIcon>
              <ListItemText primary="Exhibition Dashbord" onClick={() => history.push('/admin/exhibition/dashbord')} />
            </ListItemButton>
            <Divider sx={{ my: 1 }} />
            <Divider sx={{ my: 1 }} />
            {permissions['p_exhibition-booth-categoy-list'] === true && (
              <ListItemButton onClick={handleClickExhibitionBooth} sx={{ color: '#1976d2' }}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <ArticleIcon />
                </ListItemIcon>
                <ListItemText primary="Booth" sx={{ color: '#1976d2' }} />
                {openExhibitionBooth ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
              </ListItemButton>
            )}
            <Collapse in={openExhibitionBooth} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {permissions['p_exhibition-booth-categoy-list'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/boothcategory')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <SwipeLeftIcon onClick={() => history.push('/admin/exhibition/boothcategory')} />
                    </ListItemIcon>
                    <ListItemText primary="BoothCategory" onClick={() => history.push('/admin/exhibition/boothcategory')} />
                  </ListItemButton>
                )}
                {permissions['p_exhibition-booth-list'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/booth')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <SwipeLeftIcon onClick={() => history.push('/admin/exhibition/booth')} />
                    </ListItemIcon>
                    <ListItemText primary="Booth" onClick={() => history.push('/admin/exhibition/booth')} />
                  </ListItemButton>
                )}
                <Divider sx={{ my: 1 }} />
              </List>
            </Collapse>
            <Divider sx={{ my: 1 }} />
            {permissions['p_exhibition-booking-list'] === true && (
              <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/booking')}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <CommentIcon />
                </ListItemIcon>
                <ListItemText primary="Booking" onClick={() => history.push('/admin/exhibition/booking')} />
              </ListItemButton>
            )}
            <Divider sx={{ my: 1 }} />
            {permissions['p_exhibition-exhibitor-categoy-list'] === true && (
              <ListItemButton onClick={handleClickExhibitionExhibitor} sx={{ color: '#1976d2' }}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <ArticleIcon />
                </ListItemIcon>
                <ListItemText primary="Exhibitors" sx={{ color: '#1976d2' }} />
                {openExhibitionExhibitor ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
              </ListItemButton>
            )}
            <Collapse in={openExhibitionExhibitor} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {permissions['p_exhibition-exhibitor-categoy-list'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/exhibitor')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <SwipeLeftIcon />
                    </ListItemIcon>
                    <ListItemText primary="Exhibitor Category" onClick={() => history.push('/admin/exhibition/exhibitor')} />
                  </ListItemButton>
                )}
                {permissions['p_exhibition-exhibitor-list'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/allexhibitor')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <SwipeLeftIcon />
                    </ListItemIcon>
                    <ListItemText primary="Exhibitor" onClick={() => history.push('/admin/exhibition/allexhibitor')} />
                  </ListItemButton>
                )}
                <Divider sx={{ my: 1 }} />
              </List>
            </Collapse>
            <Divider sx={{ my: 1 }} />
            {permissions['p_exhibition-visitor-list'] === true && (
              <ListItemButton onClick={() => history.push('/admin/exhibition/visitor')}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <GroupAddIcon onClick={() => history.push('/admin/exhibition/visitor')} />
                </ListItemIcon>
                <ListItemText primary="Visitor's" onClick={() => history.push('/admin/exhibition/visitor')} />
              </ListItemButton>
            )}
            {permissions['p_exhibition-register-guest-list'] === true && (
              <ListItemButton onClick={() => history.push('/admin/exhibition/guest')}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <GroupAddIcon onClick={() => history.push('/admin/exhibition/guest')} />
                </ListItemIcon>
                <ListItemText primary="Guest's" onClick={() => history.push('/admin/exhibition/guest')} />
              </ListItemButton>
            )}
            {permissions['p_exhibition-self-scan-qr-code-list'] === true && (
              <ListItemButton onClick={() => history.push('/admin/exhibitor/scan')}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <GroupAddIcon onClick={() => history.push('/admin/exhibitor/scan')} />
                </ListItemIcon>
                <ListItemText primary="QR Code Scan" onClick={() => history.push('/admin/exhibitor/scan')} />
              </ListItemButton>
            )}
            {permissions['p_exhibition-product-and-services-list'] === true && (
              <ListItemButton onClick={handleClickExhibitionGuestFrom} sx={{ color: '#1976d2' }}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <ArticleIcon />
                </ListItemIcon>
                <ListItemText primary="Guest From" sx={{ color: '#1976d2' }} />
                {openExhibitionGuestFrom ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
              </ListItemButton>
            )}
            <Collapse in={openExhibitionGuestFrom} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {permissions['p_exhibition-product-and-services-list'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/index-services')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <SwipeLeftIcon />
                    </ListItemIcon>
                    <ListItemText primary="Products and services" onClick={() => history.push('/admin/exhibition/index-services')} />
                  </ListItemButton>
                )}
                {permissions['p_exhibition-nature-of-business-list'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/index-nature')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <SwipeLeftIcon />
                    </ListItemIcon>
                    <ListItemText primary="Nature of business" onClick={() => history.push('/admin/exhibition/index-nature')} />
                  </ListItemButton>
                )}
                <Divider sx={{ my: 1 }} />
              </List>
            </Collapse>
            <Divider sx={{ my: 1 }} />
            {currentPath !== '/admin/events' && (
              <ListItemButton onClick={handleClickExhibitionSetting} sx={{ color: '#1976d2' }}>
                <ListItemIcon sx={{ color: '#1976d2' }}>
                  <AppSettingsAltIcon />
                </ListItemIcon>
                <ListItemText primary="Setting" sx={{ color: '#1976d2' }} />
                {openExhibitionSetting ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
              </ListItemButton>
            )}
            <Collapse in={openExhibitionSetting} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/exhibitor-profile')}>
                  <ListItemIcon sx={{ color: '#1976d2' }}>
                    <ContactPageIcon />
                  </ListItemIcon>
                  <ListItemText primary="Profile" onClick={() => history.push('/admin/exhibition/exhibitor-profile')} />
                </ListItemButton>
                {permissions['p_exhibition-guest-badge-design-list'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/badge')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <ContactPageIcon />
                    </ListItemIcon>
                    <ListItemText primary="Guest Badge Design" onClick={() => history.push('/admin/exhibition/badge')} />
                  </ListItemButton>
                )}
                {permissions['p_event-email-template'] === true && (
                  <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/exhibition/index-email')}>
                    <ListItemIcon sx={{ color: '#1976d2' }}>
                      <ContactPageIcon />
                    </ListItemIcon>
                    <ListItemText primary="Email Template" onClick={() => history.push('/admin/exhibition/index-email')} />
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </List>
        )}
      </Collapse>
    </div>
  );
};

export default ExhibitionNav;